import {decompressUUIDs} from "../utils/uuid.ts";
import {CloudRepository} from "../helpers";
import {
    ExperienceTypes,
    IComponentConfig, IDedicatedSkinConfig,
    ISegmentedSkinConfig,
    ISegmentExperience, ISkinInstanceConfig,
    SkinSelectorTypes
} from "../common";

export const checkMyopOverride = async (componentConfig: IComponentConfig): Promise<IComponentConfig | null> => {
    try {
        //TODO: support disabling the mechanism
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const myopOverride = params.get('myopOverride');
        if (myopOverride) {
            const [source, ...uuids] = decompressUUIDs(myopOverride);

            switch (source) {
                case 'component': {
                    const [componentId, skinId] = uuids;
                    const componentToOverride = await CloudRepository.Main.fetchComponent(componentId);
                    if (componentToOverride) {
                        // todo: check fetchAutoFlow. Looks like only one skin is returned
                        const skin = componentToOverride.type.skins.find(skin => skin.id === skinId);
                        if (skin) {
                            // todo: for now just set skin id. Check the cloud implementation

                            componentToOverride.instance.skinSelector = {
                                type: SkinSelectorTypes.Dedicated,
                                skin: {
                                    id: skinId
                                } as ISkinInstanceConfig

                            } as IDedicatedSkinConfig;

                            return componentToOverride
                        }
                    }
                }
                    break;
            //    case 'flow': {
                default : {
                   // const [flowId, experimentId] = uuids;
                    const [flowId, experimentId] = decompressUUIDs(myopOverride);
                    const flow = await CloudRepository.Main.fetchFlow(flowId);
                    const componentToOverride = flow.components.find(c => c.type.id === componentConfig.type.id);
                    if (componentToOverride) {
                        if (componentToOverride.instance.skinSelector.type === SkinSelectorTypes.Segmented) {

                            if (componentToOverride.instance.resolvedExperiences) {
                                const resolvedExperience = componentToOverride.instance.resolvedExperiences.find(e => e.id === experimentId);

                                if (resolvedExperience?.type === ExperienceTypes.Segment) {

                                    const typedResolvedExperience = resolvedExperience as ISegmentExperience

                                    const typedSkinSelector = componentToOverride.instance.skinSelector as ISegmentedSkinConfig
                                    const segment = typedSkinSelector.segments.find(s => s.segmentId === typedResolvedExperience.segment.id);
                                    if (segment) {
                                        componentToOverride.instance.skinSelector = segment?.skinSelector;
                                        return componentToOverride;
                                    }
                                }
                            }
                        }
                    }
                }
                    break;
            }
        }
    } finally {
        return null;
    }
}